import { TierSort } from './../tierSort/tierSort';
import { Tier } from '../tier/tier';
import { TierRate } from '../../interfaces';

export class SingleTierTax {

    tax: number;

    constructor(tiers: TierRate[], amount: number) {
      const t = new TierSort(tiers).tiers;
      const a = amount || 0;

      const applicableTier = t.filter(tier => tier.to === undefined || a <= tier.to)[0];
      
      this.tax = applicableTier
        ? Math.round(new Tier(applicableTier).tax(a))
        : 0;
    }
  
  }
  